module.exports = __webpack_public_path__ + "static/img/download-error.1d1c77d1.png";